<template>
    <div class="newFlicker">
        <div class="breadcrumb">闪屏管理 >
            <span v-if="edit === false">新增闪屏</span>
            <span v-if="edit !== false">编辑闪屏</span>
            <span>
                <el-button class="right_f" type="primary" @click="cancel">取消</el-button>
                <el-button class="right_f" type="primary" @click="save(0)">保存草稿</el-button>
                <el-button class="right_f" type="primary" @click="save(1)">发布</el-button>
            </span>
        </div>

        <div class="detail">
            <el-form ref="flickerForm" :rules="rules" :model="flickerForm" label-width="130px">
                <el-form-item label="终端：" prop="appSource">
                    <el-radio v-model="flickerForm.appSource" label="0">全部</el-radio>
                    <el-radio v-model="flickerForm.appSource" label="1">安卓</el-radio>
                    <el-radio v-model="flickerForm.appSource" label="2">IOS</el-radio>
                </el-form-item>
                <el-form-item label="广告说明：" prop="description">
                    <el-input v-model="flickerForm.description" placeholder="广告说明" class="flickerTitle"></el-input>
                </el-form-item>

                <select-school :schObj="flickerForm.schObj" @changeVal="getVal"></select-school>

                <el-form-item label="起止日期：" prop="qizhiDate" required>
                    <el-form-item prop="startTime" class="time">
                        <el-date-picker v-model="flickerForm.startTime" format="yyyy/MM/dd" placeholder="yyyy/MM/dd"
                            class="qizhiDate"></el-date-picker>
                    </el-form-item>
                    &nbsp;&nbsp;至&nbsp;&nbsp;
                    <el-form-item prop="endTime" class="time">
                        <el-date-picker v-model="flickerForm.endTime" class="qizhiDate" format="yyyy/MM/dd"
                            placeholder="yyyy/MM/dd"></el-date-picker>
                    </el-form-item>
                </el-form-item>
                <el-form-item label="主标题：" prop="mainTitle">
                    <el-input v-model="flickerForm.mainTitle" class="flickerTitle" placeholder="请填写正确的主标题，不超过10个字符">
                    </el-input>
                </el-form-item>
                <el-form-item label="副标题：" prop="subTitle">
                    <el-input v-model="flickerForm.subTitle" class="flickerTitle" placeholder="请填写正确的副标题，不超过14个字符">
                    </el-input>
                </el-form-item>
                <el-form-item label="LOGO：" prop="logo">
                    <el-upload :action="logoActionUrl" :with-credentials='true' accept="image/*" name="picFile"
                        type="drag" :thumbnail-mode="true" :on-error="handleError" :on-success="handleSuccess_logo">
                        <i class="el-icon-upload"></i>
                        <div class="el-dragger__text">将文件拖到此处，或
                            <em>点击上传</em>
                        </div>
                    </el-upload>
                    <span class="gray">（尺寸说明：88×88像素，jpg、jpeg、png）</span>
                </el-form-item>
                <!-- <el-form-item label="URL地址：" prop="urlAddress">
                    <el-input v-model="flickerForm.urlAddress" class="flickerTitle" placeholder="请填写正确的URL地址"></el-input>
                </el-form-item> -->
                <!-- ........................ -->
                <el-form-item label="点击事件：" prop="type" required>
                    <el-radio v-model="flickerForm.type" label="-1">无跳转</el-radio>
                    <el-radio v-model="flickerForm.type" label="1">跳转至URL：</el-radio>
                    <el-radio v-model="flickerForm.type" label="2">跳转至微信小程序：</el-radio>
                    <el-radio v-model="flickerForm.type" label="3">跳转至支付宝小程序：</el-radio>
                </el-form-item>
                <el-form-item prop="urlAddress" v-if="flickerForm.type === '1'" class="wxApp-from-1">
                    <el-input v-model="flickerForm.urlAddress" placeholder="请填写正确的URL地址"></el-input>
                </el-form-item>
                <!-- 微信小程序 -->
                <div v-if="flickerForm.type == '2'">
                    <el-form-item label="小程序原始ID：" prop="wxAppId" class="wxApp-from" required>
                        <el-input v-model="flickerForm.wxAppId" placeholder="请填写正确的小程序原始ID"></el-input>
                    </el-form-item>
                    <el-form-item label="路径地址：" class="wxApp-from">
                        <el-input v-model="flickerForm.wxAppUrl" placeholder="请填写正确的路径地址"></el-input>
                    </el-form-item>
                </div>
                <!-- 支付宝小程序 -->
                <div v-if="flickerForm.type == '3'" class="wx-app">
                    <el-form-item label="小程序原始ID：" class="wxApp-from" required>
                        <el-input v-model="flickerForm.aliAppId" placeholder="请填写正确的小程序原始ID"></el-input>
                    </el-form-item>
                    <el-form-item label="路径地址：" class="wxApp-from">
                        <el-input v-model="flickerForm.aliAppUrl" placeholder="请填写正确的路径地址"></el-input>
                    </el-form-item>
                </div>
                <!-- ............................. -->
                <el-form-item label="闪屏图片：" prop="picture">
                    <el-upload :action="pictureActionUrl" :with-credentials='true' accept="image/*" name="picFile"
                        type="drag" :thumbnail-mode="true" :on-error="handleError" :on-success="handleSuccess">
                        <i class="el-icon-upload"></i>
                        <div class="el-dragger__text">将文件拖到此处，或
                            <em>点击上传</em>
                        </div>
                    </el-upload>
                    <span class="gray">（尺寸说明：750×1125像素，jpg、jpeg、GIF、png）</span>
                </el-form-item>
                <el-form-item label="广告曝光代码:" prop="adExposingCodes" class="bannerContent">
                    <el-input type="textarea" :autosize="{minRows: 5}" placeholder="在这里粘贴"
                        v-model="flickerForm.adExposingCodes">
                    </el-input>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import { mapActions } from 'vuex'
    import selectSchool from "../../common/selectSch.vue"

    export default {
        data() {
            return {
                logoActionUrl: this.$util.domain + '/adminapi/v1/ad/adFlash/add/picture?uploadType=0',
                pictureActionUrl: this.$util.domain + '/adminapi/v1/ad/adFlash/add/picture?uploadType=1',
                edit: false,
                operatorId: '',
                flickerForm: {
                    appSource: "0",
                    description: "",
                    schObj: {
                        applicableCampus: "1",
                        shieldedSchools: [], //屏蔽的学校
                        openedSchools: []//应用的学校
                    },
                    logo: "",
                    picture: "",
                    urlAddress: "",
                    mainTitle: "",
                    subTitle: "",
                    qizhiDate: "yyyy/mm/dd",
                    startTime: "",
                    endTime: "",
                    id: "",
                    adExposingCodes: "",
                    wxAppId: '',
                    wxAppUrl: '',
                    aliAppId: '',
                    aliAppUrl: '',
                    type: '-1'
                },
                rules: {
                    mainTitle: [
                        { max: 10, message: '主标题长度不超过10个字符', trigger: 'blur' },
                    ],
                    subTitle: [
                        { max: 14, message: '副标题长度不超过14个字符', trigger: 'blur' },
                    ],
                    picture: [
                        { required: true, message: '请上传闪屏图片', trigger: 'change' }
                    ]
                }
            }
        },
        components: { selectSchool },
        mounted() {
            this.operatorId = this.$store.state.user.userId;

            let url = window.location.href;

            if (url.indexOf('?') !== -1) {
                this.edit = true;
                let flickerId = this.$util.getUrlParam('flickerId');
                this.getflickerDetail(flickerId);
            }
        },
        methods: {
            ...mapActions(['SIGNOUT']),

            //获取子组件传递的参数
            getVal(res) {
                this.flickerForm.schObj = res;
            },
            /**新增闪屏**/
            add(num) {
                let startTime = new Date(this.flickerForm.startTime).format("yyyy-MM-dd 00:00");
                startTime = new Date(startTime);
                let endTime = new Date(this.flickerForm.endTime).format("yyyy-MM-dd 00:00");
                endTime = new Date(endTime);
                if (!this.flickerForm.startTime || !this.flickerForm.endTime) {
                    this.$util.errorMsg("请填写开始时间或结束时间");
                    return;
                }
                if (startTime.getTime() > endTime.getTime()) {
                    this.$util.errorMsg("请填写正确的结束时间");
                    return;
                }

                // url地址为空的验证
                if (this.flickerForm.type == '1' && !this.flickerForm.urlAddress.trim()) {
                    this.$util.errorMsg("点击事件的id或者url不能为空！");
                    return;
                }

                if (this.flickerForm.type === '2' && !this.flickerForm.wxAppId.trim()) {
                    this.$util.errorMsg("微信小程序的原始id不能为空！");
                    return;
                }

                if (this.flickerForm.type === '2' && this.flickerForm.wxAppId.indexOf('id=') > -1) {
                    this.$util.errorMsg("微信小程序的原始id输入格式错误！");
                    return;
                }
                if (this.flickerForm.type === '3' && !this.flickerForm.aliAppId.trim()) {
                    this.$util.errorMsg("支付宝小程序的原始id不能为空！");
                    return;
                }

                if (this.flickerForm.type === '3' && this.flickerForm.aliAppId.indexOf('appId=') > -1) {
                    this.$util.errorMsg("支付宝小程序的原始id输入格式错误！");
                    return;
                }

                let rootUnids = [], schObj = this.flickerForm.schObj;
                if (schObj.applicableCampus == 0 && schObj.shieldedSchools.length) {
                    for (let i = 0; i < schObj.shieldedSchools.length; i++) {
                        rootUnids.push(schObj.shieldedSchools[i].rootUnid * 1)
                    }
                } else if (schObj.applicableCampus == 1 && schObj.openedSchools.length) {
                    for (let i = 0; i < schObj.openedSchools.length; i++) {
                        rootUnids.push(schObj.openedSchools[i].rootUnid * 1)
                    }
                }

                if (this.flickerForm.type == '-1') {
                    this.flickerForm.urlAddress = '';
                } else if (this.flickerForm.type == '2') {
                    // 小程序的id和url作为两个参数拼成字符串传给后台
                    if (this.flickerForm.wxAppUrl && this.flickerForm.wxAppUrl.trim()) {
                        this.flickerForm.urlAddress = 'id=' + this.flickerForm.wxAppId.trim() + '&path=' + this.flickerForm.wxAppUrl.trim();
                    } else {
                        this.flickerForm.urlAddress = 'id=' + this.flickerForm.wxAppId.trim();
                    }
                } else if (this.flickerForm.type == '3') {
                    // 支付宝小程序的id和url作为两个参数拼成字符串传给后台
                    if (this.flickerForm.aliAppUrl && this.flickerForm.aliAppUrl.trim()) {
                        this.flickerForm.urlAddress = 'appId=' + this.flickerForm.aliAppId.trim() + '&page=' + this.flickerForm.aliAppUrl.trim();
                    } else {
                        this.flickerForm.urlAddress = 'appId=' + this.flickerForm.aliAppId.trim();
                    }
                }

                // 入参的空格过滤

                let requestBody = {
                    operateType: num * 1,//操作类型，0草稿，1发布
                    startTime: startTime.getTime(),
                    endTime: endTime.getTime(),
                    description: this.flickerForm.description.trim(),
                    appSource: this.flickerForm.appSource * 1,
                    picture: this.flickerForm.picture,
                    mainTitle: this.flickerForm.mainTitle.trim(),
                    subtitle: this.flickerForm.subTitle.trim(),
                    applicableCampus: schObj.applicableCampus * 1,
                    adExposingCodes: this.flickerForm.adExposingCodes.trim(),
                    logo: this.flickerForm.logo,
                    operatorId: this.operatorId * 1,// 管理员id
                    url: this.flickerForm.urlAddress.trim(),
                    rootUnids: rootUnids,
                    type: this.flickerForm.type
                };
                let url;
                if (this.edit) {
                    requestBody.id = this.$util.getUrlParam('flickerId') * 1;
                    url = this.$util.domain + '/adminapi/v2/ad/adFlash/edit';
                } else {
                    url = this.$util.domain + '/adminapi/v2/ad/adFlash/add';
                }
                this.$http({
                    url,
                    method: 'POST',
                    body: JSON.stringify(requestBody)
                }).then(response => {
                    if (response.data.error === 10000) {
                        location.href = '/#/yunying/flicker/flickerScreen';
                    } else {
                        this.$util.errorMsg(response.data.message);
                    }
                }).catch(response => {
                    this.$util.errorMsg(response.data.message);
                })

            },
            // 获取闪屏详情
            getflickerDetail(id) {
                this.$http({
                    method: 'GET',
                    url: this.$util.domain + '/adminapi/v2/ad/adFlash/detail/' + id,
                    params: {
                        id: id * 1
                    }
                }).then((response) => {
                    if (response.data.error === 10000) {
                        let data = response.data.data;

                        // 点击事件的ID或URL的整理
                        let url = '', wxAppId = '', wxAppUrl = '', aliAppId = '', aliAppUrl = '';
                        if (data.type == 2) {
                            // 微信小程序地址拆分
                            wxAppId = this.$util.getUrlParam('id', data.url);
                            wxAppUrl = this.$util.getUrlParam('path', data.url);
                        } else if (data.type === 3) {
                            // 支付宝小程序地址拆分
                            aliAppId = this.$util.getUrlParam('appId', data.url);
                            aliAppUrl = this.$util.getUrlParam('page', data.url);
                            let query = this.$util.getUrlParam('query', data.url);
                            if (query) {
                                aliAppUrl = aliAppUrl + '&query=' + query;
                            }
                        } else if (data.type == -1) {
                            url = '';
                        } else {
                            url = data.url;
                        }

                        this.flickerForm = {
                            appSource: data.appSource + '',
                            description: data.description || '',
                            schObj: {
                                applicableCampus: data.applicableCampus + '',
                                shieldedSchools: [], //屏蔽的学校
                                openedSchools: []//应用的学校
                            },
                            logo: data.logo,
                            picture: data.picture,
                            urlAddress: url ? url + '' : '',
                            mainTitle: data.mainTitle || '',
                            subTitle: data.subtitle || '',
                            startTime: data.startTime,
                            endTime: data.endTime,
                            id: data.id,
                            adExposingCodes: data.adExposingCodes || '',
                            type: data.type + '',
                            wxAppId: wxAppId,
                            wxAppUrl: wxAppUrl,
                            aliAppId: aliAppId,
                            aliAppUrl: aliAppUrl
                        };
                        data.applicableCampus == 0
                            ? this.flickerForm.schObj.shieldedSchools = data.campusList
                            : this.flickerForm.schObj.openedSchools = data.campusList;
                    }
                })

            },
            //保存和发布：0：保存；1：发布；
            save(status) {

                if (!this.flickerForm.picture) {
                    this.$util.errorMsg("请上传闪屏图片");
                    return;
                }

                if (this.flickerForm.schObj.applicableCampus == '1' && this.flickerForm.schObj.openedSchools.length == 0) {
                    this.$util.errorMsg("请添加应用学校");
                    return;
                }
                this.$refs.flickerForm.validate((valid) => {
                    if (valid) {
                        this.add(status);
                    }
                })
            },
            //取消
            cancel() {
                history.go(-1);
            },
            //上传picture文件成功钩子
            handleSuccess(response) {
                if (response.error !== 10000) {
                    this.$util.errorMsg('上传失败');
                } else {
                    this.flickerForm.picture = response.data;
                }
            },
            // logo
            handleSuccess_logo(response) {
                if (response.error !== 10000) {
                    this.$util.errorMsg('上传失败');
                } else {
                    this.flickerForm.logo = response.data;
                }
            },
            //上传文件失败钩子
            handleError(response) {
                if (response.status === 403) {
                    this.SIGNOUT();
                    location.href = '/#';
                }
                this.$util.errorMsg('上传失败');
            }
        }
    }

</script>
<style>
    .inline {
        display: inline-block;
        margin-right: 20px;
        margin-bottom: 15px;
    }

    .btn_newFlicker+.btn_newFlicker {
        margin-left: 0;
    }

    .flickerTitle {
        width: 40%;
    }

    .flickerZhouqi {
        width: 20%;
    }

    .qizhiDate {
        display: inline-block;
        width: 100%;
    }

    .flickerContent {
        width: 98%;
    }

    .newFlicker .el-form-item .el-radio {
        display: block;
        margin-left: 0;
        width: 200px;
    }

    .newFlicker .wxApp-from {
        margin-left: 120px;
        margin-bottom: 10px;
    }

    .newFlicker .wxApp-from .el-input {
        width: 60%;
    }

    .wxApp-from-1 .el-input {
        width: 60%;
    }

    .bannerContent {
        min-width: 700px;
        width: 70%;
    }

    .newFlicker .irregular {
        display: inline-block;
    }

    .gray {
        color: #999;
    }

    .newFlicker .time {
        display: inline-block;
        width: 15%;
    }

    .flickerContent {
        min-width: 700px;
        width: 70%;
    }
</style>


// WEBPACK FOOTER //
// newFlickerScreen.vue?6494f33a